import { Link, useLocation } from "react-router-dom";

export default function NavLink({ href, children }) {
  const { pathname } = useLocation();
  const isActive = href === pathname;

  return (
    <Link
      to={href}
      className={`${
        isActive ? "text-blue-600" : "text-slate-700"
      } inline-block font-bold rounded-lg px-2 py-2 text-sm hover:bg-slate-100 hover:text-slate-900`}
    >
      {children}
    </Link>
  );
}
